import baseUrl from './baseUrl';

export default baseUrl === 'https://giztixgps.giztix.com' ? 'AIzaSyD2g6CXdO0BQE63OmxAdYAzAkTCx0a42UM' : 'AIzaSyDi5x7PhCh_CNMDD4Pzcl_syLdTQeDlP6E';
